import { jobStates } from '@/constants/manageJobsStatus';

export function findStatusObjectByJobStatus(status) {
  return Object.values(jobStates).find(
    (item) => item.value === status
  )
}
